
    const original = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"8\" viewBox=\"0 0 9 8\">\n  <path fill=\"none\" stroke=\"#855CD6\" stroke-width=\"2\" d=\"M1 7.333L7.333 1M1 1L7.333 7.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
